// src/data/content.js
const content = {
  home: [
    {
      type: "textandform",
      headline: {
        type: "h1",
        text: "Das moderne Reisebüro"
      },
      text: "<p>Wir sind ein Team aus Unternehmer:innen und Techniker:innen, die etwas Neues aufbauen - mit Reisberater:innen, kreativen Köpfen und Enthusiasten im Mittelpunkt.</p><p>Schreiben Sie sich in die Warteliste ein, um Ihren Platz zu sichern.</p>",
    },
    {
      type: "imageleftright",
      left: "https://findaro-travel.imgix.net/beautiful-bay-people-bathing-boats.jpg?w=750&h=780&fit=crop&auto=format",
      right: "https://findaro-travel.imgix.net/Stone-building-greece-architecture-nature.jpg?w=750&h=780&fit=crop&auto=format",
    },
    {
      type: "headline",
      headline: {
        type: "h2",
        style: "center",
        text: "Bezahlen Sie das Gleiche (nein, wirklich).<br>Holen Sie sich VIEL mehr."
      }
    },
    {
      type: "icons",
      icons: [
        {
          icon: 'bi:list-stars',
          text: 'Personalisierte &<br> transparente Empfehlungen'
        },
        {
          icon: 'fluent:beach-20-regular',
          text: 'Killer-Vergünstigungen &<br> Hochstufungen'
        },
        {
          icon: 'fluent:person-star-20-regular',
          text: 'Insiderwissen'
        },

        {
          icon: 'pepicons-pencil:persons',
          text: 'Wir unterstützen Sie'
        },
      ]
    },
    {
      type: "imageandtext",
      image: "https://findaro-travel.imgix.net/woman-reading-magazine.png?w=765&h=832&fit=crop&auto=format",
      headline: {
        type: "h2",
        text: "Sind Sie die erste Adresse für Reisetipps?"
      },
      text: "<p>Verwandeln Sie Ihre Leidenschaft in Ihren Traumjob. Wir zeigen Ihnen, wie es geht und sorgen dafür, dass Sie großartig aussehen. Arbeiten Sie von überall aus, als Nebenjob oder Vollzeit - das ist der beste Job, von dem Sie nicht wussten, dass es ihn gibt.</p>",
      button: {
        text: "Mehr erfahren",
        href: "/berater"
      },
    },
  ],
  berater: [
    {
      type: "textandformsub",
      headline: {
        type: "h1",
        text: "Verwandeln Sie Ihre Leidenschaft für das Reisen in €€€."
      },
      text: "<p>Bald verfügbar! Treten Sie einer Gemeinschaft von Reiseexperten und -expertinnen bei. Arbeiten Sie von überall aus, nebenberuflich oder Vollzeit - der beste Job, von dem Sie nicht wussten, dass er existiert.</p>",
      image1: "https://findaro-travel.imgix.net/woman-reads-travel-guide-front-of-wall.jpg?w=281&h=264&fit=crop&auto=format",
      image2: "https://findaro-travel.imgix.net/sea-view-santorini-white-building-with-blue-dome.jpg?w=281&h=384&fit=crop&auto=format",
      image3: "https://findaro-travel.imgix.net/woman-sits-beach-dips-feet-in-water.jpg?w=281&h=384&fit=crop&crop=entropy&auto=format",
      image4: "https://findaro-travel.imgix.net/woman-reading-book-outdoor.jpg?w=281&h=264&fit=crop&auto=format",
    },
    {
      type: "headline",
      headline: {
        type: "h2",
        style: "center",
        text: "Sind Sie die Ansprechperson<br>für Reisetipps?"
      },
      text: "Willkommen zu Hause."
    },
    {
      type: "listimage",
      headline: "Entwickelt, um Sie strahlen zu lassen",
      image: "https://findaro-travel.imgix.net/workplace-laptop-remote-work.jpg?w=577&h=576&fit=crop&auto=format&crop=right",
      list: [
        {
          text: 'Schöne Profilseiten'
        },
        {
          text: 'Clevere Tools zur Erstellung von Reiserouten und Inhalten'
        },
        {
          text: 'Einfach zu bedienende Marketing-Plattform'
        }
      ]
    },
    {
      type: "listimage",
      headline: "Ein “soziales” Netzwerk",
      image: "https://findaro-travel.imgix.net/Three-women-discuss-working-laptop.jpg?w=577&h=576&fit=crop&auto=format",
      list: [
        {
          text: 'Live, interaktive Informationen zu Reisezielen'
        },
        {
          text: 'Online Ausbildung und Training'
        },
        {
          text: 'Gemeinschaft-Forum für Ihre Fragen & Antworten'
        }
      ]
    },
    {
      type: "listimage",
      headline: "Dein Traumjob - im Bereich Reisen",
      image: "https://findaro-travel.imgix.net/Colorful-buildings-oia-santorini-along-cliffside.jpg?w=577&h=576&fit=crop&auto=format",
      list: [
        {
          text: 'Verwandeln Sie Ihre Leidenschaft in Einnahmen und Vorteile'
        },
        {
          text: 'Werden Sie Teil der besten Branche mit den besten Leuten'
        },
        {
          text: 'Arbeiten Sie, wann Sie wollen, so viel Sie wollen, von wo immer Sie wollen'
        }
      ]
    },
    {
      type: "listimage",
      headline: "Insider-Zugang und Vorteile",
      image: "https://findaro-travel.imgix.net/table-food-drinks-swimming-pool-relaxation.jpg?w=577&h=576&fit=crop&auto=format&crop=bottom",
      list: [
        {
          text: 'Erfahren Sie von Neueröffnungen noch vor allen anderen'
        },
        {
          text: 'Automatische Verbesserungen und Gratisangebote'
        },
        {
          text: 'Werden Sie ein Insider der Reisebranche'
        }
      ]
    },
  ]
};

export default content;
